module.exports = __webpack_public_path__ + "static/media/12485925_1502318150076707_4288482379753630176_o.92fc9464.jpg";